export const addContentConstants = {
    CONTENT_CREATION_FAILURE: "CONTENT_CREATION_FAILURE",
    CONTENT_CREATION_SUCCESS: "CONTENT_CREATION_SUCCESS",
}